import { get } from "@/utils/api";

export interface ParlorAutocompleteResponse {
  id: number;
  companyname: string;
  address: string;
}

export const getParlorAutocomplete = async (query?: string) => {
  if (query) {
    return await get(`/parlors/autocomplete/?query=${query}`);
  }

  return await get("/parlors/autocomplete/");
};
